/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SendContractToSignCommand } from '../../models/send-contract-to-sign-command';
import { SuccessApiResponse } from '../../models/success-api-response';

export interface SendContratToSign$Plain$Params {
      body?: SendContractToSignCommand
}

export function sendContratToSign$Plain(http: HttpClient, rootUrl: string, params?: SendContratToSign$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SuccessApiResponse>> {
  const rb = new RequestBuilder(rootUrl, sendContratToSign$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SuccessApiResponse>;
    })
  );
}

sendContratToSign$Plain.PATH = '/api/contract/sign-contract';
